import { Certificates } from 'views/certificates';
import { Companies } from 'views/companies';
import { ActivityLog } from 'views/customers/ActivityLog';
import { CertificatesC } from 'views/customers/Certificates';
import { Company } from 'views/customers/Company/company';
import { Contacts } from 'views/customers/Contacts/contacts';
import { DocumentsActive } from 'views/customers/Documents/Actives';
import { DocumentsArchived } from 'views/customers/Documents/Archived';
import { Drivers } from 'views/customers/Drivers/Active';
import { DriversArchived } from 'views/customers/Drivers/Archived';
import { Endorsements } from 'views/customers/Endorsements';
import { ActivePolicies } from 'views/customers/Policies/Active';
import { CanceledPolicies } from 'views/customers/Policies/Canceled';
import { PendingCancellationPolicies } from 'views/customers/Policies/Pending_Cancellation';
import { QuotesC } from 'views/customers/Quotes';
import { TrailersActive } from 'views/customers/Trailers/Active';
import { TrailersArchived } from 'views/customers/Trailers/Archived';
import { VehiclesActive } from 'views/customers/Vehicles/Active';
import { VehiclesArchived } from 'views/customers/Vehicles/Archived';
import { Dashboard } from 'views/dashboard/dashboard';
// NOTE: Remove only if client approves endorsement v2
// import { Endorsement } from 'views/endorsement';
// import { EndorsementView } from 'views/endorsementView';
import { Help } from 'views/help';
import { OnboardingPage } from 'views/onboarding/dashboard';
import { Policies } from 'views/policies';
import { Quote } from 'views/quote';
import { ReviewPolicy } from 'views/reviewPolicy';
import { ReviewQuote } from 'views/reviewQuote';
import { RunEndorsemenet } from 'views/runEndorsement';
import { RunQuote } from 'views/runQuote';
import { IndividualQuote } from 'views/individualQuote';
import { ServiceCenter } from 'views/service_center';
import TicketPage from 'views/service_center/ticket';
import { Snapshot } from 'views/snapshot';
import { Support } from 'views/support';
import RenewalDetails from 'views/renewal/renewal_details';
import { Renewals } from '../views/renewal';
import BindRequestDetails from "../views/bindRequests/bind_request_details";
import { BindRequests } from "../views/bindRequests";
import Notes from 'views/customers/Notes';
import EndorsementsV2 from 'views/endorsementsV2';
import EndorsementsViewV2 from 'views/endorsementViewV2';

const Routes = [
  {
    path: '/app/dashboard',
    view: Dashboard,
    layout: 'app',
    permission: 'user',
    title: 'Dashboard',
  },
  {
    path: '/app/onboarding',
    view: OnboardingPage,
    layout: 'auth',
    permission: 'user',
    title: 'Onboarding',
  },
  {
    path: '/app/companies',
    view: Companies,
    layout: 'app',
    permission: 'user',
    title: 'Companies',
  },
  {
    path: '/app/company/:id/info',
    view: Company,
    layout: 'app',
    permission: 'user',
    title: 'Company - Info',
  },
  {
    path: '/app/company/:id/contacts',
    view: Contacts,
    layout: 'app',
    permission: 'user',
    title: 'Company - Contacts',
  },
  {
    path: '/app/company/:id/policies',
    view: ActivePolicies,
    layout: 'app',
    permission: 'user',
    title: 'Polices - Active',
  },
  {
    path: '/app/company/:id/policies/pending_cancellation',
    view: PendingCancellationPolicies,
    layout: 'app',
    permission: 'user',
    title: 'Polices - Pending Cancellation',
  },
  {
    path: '/app/company/:id/policies/canceled',
    view: CanceledPolicies,
    layout: 'app',
    permission: 'user',
    title: 'Polices - Canceled',
  },
  {
    path: '/app/company/:id/endorsements',
    view: Endorsements,
    layout: 'app',
    permission: 'user',
    title: 'Endorsements',
  },
  {
    path: '/app/company/:id/certificates',
    view: CertificatesC,
    layout: 'app',
    permission: 'user',
    title: 'Certificates',
  },
  {
    path: '/app/company/:id/quotes',
    view: QuotesC,
    layout: 'app',
    permission: 'user',
    title: 'Quotes',
  },
  {
    path: '/app/company/:id/notes',
    view: Notes,
    layout: 'app',
    permission: 'user',
    title: 'Notes',
  },
  {
    path: '/app/quote/run',
    view: RunQuote,
    layout: 'app',
    permission: 'user',
    title: 'Run Quote',
  },
  {
    path: '/app/quote/individual',
    view: IndividualQuote,
    layout: 'app',
    permission: 'user',
    title: 'Run Personal Quote',
  },
  {
    path: '/app/endorsement/run',
    view: RunEndorsemenet,
    layout: 'app',
    permission: 'user',
    title: 'Run Endorsement',
  },
  {
    path: '/app/quote/review',
    view: ReviewQuote,
    layout: 'app',
    permission: 'user',
    title: 'Review',
  },
  {
    path: '/app/policy/review',
    view: ReviewPolicy,
    layout: 'app',
    permission: 'user',
    title: 'Review',
  },

  {
    path: '/app/company/:id/documents',
    view: DocumentsActive,
    layout: 'app',
    permission: 'user',
    title: 'Documents',
  },
  {
    path: '/app/company/:id/documents/archived',
    view: DocumentsArchived,
    layout: 'app',
    permission: 'user',
    title: 'Documents - Archived',
  },
  {
    path: '/app/company/:id/vehicles',
    view: VehiclesActive,
    layout: 'app',
    permission: 'user',
    title: 'Vehicles',
  },
  {
    path: '/app/company/:id/vehicles/archived',
    view: VehiclesArchived,
    layout: 'app',
    permission: 'user',
    title: 'Vehicles',
  },
  {
    path: '/app/company/:id/trailers',
    view: TrailersActive,
    layout: 'app',
    permission: 'user',
    title: 'Trailers',
  },
  {
    path: '/app/company/:id/trailers/archived',
    view: TrailersArchived,
    layout: 'app',
    permission: 'user',
    title: 'Trailers',
  },
  {
    path: '/app/company/:id/log',
    view: ActivityLog,
    layout: 'app',
    permission: 'user',
    title: 'Activity Logs',
  },
  {
    path: '/app/company/:id/drivers',
    view: Drivers,
    layout: 'app',
    permission: 'user',
    title: 'Drivers',
  },
  {
    path: '/app/company/:id/drivers/archived',
    view: DriversArchived,
    layout: 'app',
    permission: 'user',
    title: 'Drivers - Archived',
  },
  {
    path: '/app/quote/app',
    view: Quote,
    layout: 'app',
    permission: 'user',
    title: 'Quotes',
  },
  {
    path: '/app/policies',
    view: Policies,
    layout: 'app',
    permission: 'user',
    title: 'Policies',
  },
  {
    path: '/app/endorsements',
    // view: Endorsement,
    view: EndorsementsV2,
    layout: 'app',
    permission: 'user',
    title: 'Endorsements',
  },
  {
    path: '/app/endorsement/view/:id',
    // view: EndorsementView,
    view: EndorsementsViewV2,
    layout: 'app',
    permission: 'user',
    title: 'Endorsement View',
  },
  {
    path: '/app/certificates',
    view: Certificates,
    layout: 'app',
    permission: 'user',
    title: 'Certificates',
  },
  {
    path: '/app/snapshot',
    view: Snapshot,
    layout: 'app',
    permission: 'user',
    title: 'Snapshot',
  },
  {
    path: '/app/resources',
    view: Support,
    layout: 'app',
    permission: 'user',
    title: 'Resources',
  },
  {
    path: '/app/help',
    view: Help,
    layout: 'app',
    permission: 'user',
    title: 'Help',
  },
  {
    path: '/app/quote/progressive/review',
    view: ReviewQuote,
    layout: 'app',
    permission: 'user',
    title: 'Review Progressive Quote',
  },
  {
    path: '/app/service_center',
    view: ServiceCenter,
    layout: 'app',
    permission: 'user',
    title: 'Service Center',
  },
  {
    path: '/app/service_center/ticket/:id',
    view: TicketPage,
    layout: 'app',
    permission: 'user',
    title: 'Service Center',
  },
  {
    path: '/app/bind-requests',
    view: BindRequests,
    layout: 'app',
    permission: 'user',
    title: 'Bind Requests',
  },
  {
    path: '/app/bind-requests/:id',
    view: BindRequestDetails,
    layout: 'app',
    permission: 'user',
    title: 'Bind Requests',
  },
  {
    path: '/app/renewals',
    view: Renewals,
    layout: 'app',
    permission: 'user',
    title: 'Renewals',
  },
  {
    path: '/app/renewals/:id',
    view: RenewalDetails,
    layout: 'app',
    permission: 'user',
    title: 'Renewals',
  },
];

export default Routes;
